import classNames from 'classnames'
import { MdEdit, MdOutlineRefresh } from 'react-icons/md'
import { Handle, Position } from 'reactflow'

import type { ReactElement } from 'react'
import type { NodeProps } from 'reactflow'
import type { ITask } from '~/types/app-setup'

import Badge from '~/components/Badge'

import './styles.scss'

interface AppSetupCardProps extends ITask {
  isEditable?: boolean
  isRunnable?: boolean
  onDelete: (task: ITask) => void
  onEdit: (task: ITask) => void
  onExecute: (task: ITask) => void
  status: 'completed' | 'failed' | 'pending' | 'running' | 'skipped'
}

const AppSetupCard = ({ data }: NodeProps<AppSetupCardProps>): ReactElement => {
  /** Local state */

  const getStatus = () => {
    switch (data.status) {
      case 'completed':
        return 'Completed'
      case 'failed':
        return 'Failed'
      case 'pending':
        return 'Pending'
      case 'running':
        return 'Running'
      case 'skipped':
        return 'Skipped'
      default:
        return 'Unknown'
    }
  }

  /** Handlers */

  const handleEdit = () => data.onEdit(data)

  const handleDelete = () => data.onDelete(data)

  const handleExecute = () => data.onExecute(data)

  /** Render */

  return (
    <div
      className={classNames('app-setup-task-card-component', {
        [`app-setup-task-card-component--${data.status}`]: true,
      })}
    >
      <Handle position={Position.Top} type="target" />
      {data.isEditable ? (
        <>
          <button className="delete-button" onClick={handleDelete}>
            ×
          </button>
          <button className="edit-button" onClick={handleEdit}>
            <MdEdit size={12} />
          </button>
        </>
      ) : null}
      {data.isRunnable ? (
        <button className="execute-button" onClick={handleExecute}>
          <MdOutlineRefresh size={12} />
        </button>
      ) : null}
      <div className="section">
        <span className="app-setup-task-card-component__id">{data.id}</span> -{' '}
        <span className="app-setup-task-card-component__description">{data.description}</span>
      </div>
      <div className="app-setup-task-card-component__url">{data.url}</div>
      {data.status ? (
        <div className="app-setup-task-card-component__status">
          <Badge
            className={classNames('status-badge', {
              [`status-badge--${data.status}`]: true,
            })}
            size="medium"
            value={getStatus()}
          />
        </div>
      ) : null}
      <Handle id={data.id} position={Position.Bottom} type="source" />
    </div>
  )
}

export default AppSetupCard
